import { Layout, Row, Col } from "antd";
import { Link } from "react-router-dom";

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
          <div className="copyright">
            © {new Date().getFullYear()},
            <a href="https://www.nphl.go.ke/" className="font-weight-bold" rel="noreferrer" target="_blank">
              National Public Health Laboratories
            </a>
          </div>
        </Col>
        <Col xs={24} md={12} lg={12}>
          <div className="footer-menu">
            <ul>
              <li className="nav-item">
                <a
                  href="https://www.nphl.go.ke/"
                  className="nav-link text-muted"
                  target="_blank"
                  rel="noreferrer"
                >
                  NPHL Website
                </a>
              </li>
              <li className="nav-item">
                <Link
                  to="/about"
                  className="nav-link text-muted"
                >
                  About Us
                </Link>
              </li>
              {/* <li className="nav-item">
                <a
                  href="#pablo"
                  className="nav-link text-muted"
                  target="_blank"
                >
                  Blog
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="#pablo"
                  className="nav-link pe-0 text-muted"
                  target="_blank"
                >
                  License
                </a>
              </li> */}
            </ul>
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
